module.exports = __webpack_public_path__ + "img/1290842676.f0d29f22.jpg";